export const FETCH_GRADE_FAILURE = 'FETCH_GRADE_FAILURE';
export const FETCH_GRADE_LOADING = 'FETCH_GRADE_LOADING';
export const FETCH_GRADE_SUCCESS = 'FETCH_GRADE_SUCCESS';

export const ADD_GRADE_SUCCESS = 'ADD_GRADE_SUCCESS';
export const ADD_GRADE_FAILURE = 'ADD_GRADE_FAILURE';
export const ADD_GRADE_LOADING = 'ADD_GRADE_LOADING';

export const UPDATE_GRADE_SUCCESS = 'UPDATE_GRADE_SUCCESS';
export const UPDATE_GRADE_FAILURE = 'UPDATE_GRADE_FAILURE';
export const UPDATE_GRADE_LOADING = 'UPDATE_GRADE_LOADING';

export const DELETE_GRADE_SUCCESS = 'DELETE_GRADE_SUCCESS';
export const DELETE_GRADE_FAILURE = 'DELETE_GRADE_FAILURE';
export const DELETE_GRADE_LOADING = 'DELETE_GRADE_LOADING';
